import {register} from '@shopify/theme-sections';

const selectors = {
  slider: '[data-slider]',
};

export default register('trust', {
  onLoad() {
    const container = this.container;
    const elem = container.querySelector(selectors.slider);
    if (!elem) return;
    return new Flickity(elem, {
      freeScroll: false,
      prevNextButtons: false,
      pageDots: true,
      cellAlign: 'left',
      watchCSS: true,
      contain: true,
      groupCells: true,
      imagesLoaded: true,
    });
  },
});
